import { render, staticRenderFns } from "./Page4.vue?vue&type=template&id=691a2b94&scoped=true&"
import script from "./Page4.vue?vue&type=script&lang=js&"
export * from "./Page4.vue?vue&type=script&lang=js&"
import style0 from "./Page4.vue?vue&type=style&index=0&id=691a2b94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691a2b94",
  null
  
)

export default component.exports